import React from "react";
import { Icon } from "./Icon";

interface CreditCardProps {
  size?: number;
  className?: string;
  viewBox?: string;
  color?: string;
}

export const PixOpenFinancePay2B: React.FC<CreditCardProps> = ({
  size = 16,
  className = "",
  viewBox = "0 0 16 16",
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color} viewBox={viewBox}>
      <path d="M9.95299 1.61947C4.90902 1.61947 2.46705 8.25191 5.58174 12.1431C6.66344 13.4885 8.20745 14.3835 9.95299 14.3835C11.0288 14.3835 12.0364 14.0545 12.8988 13.4826C11.6007 14.6443 9.8789 15.3496 8 15.3496C7.88442 15.3496 7.76292 15.3496 7.64734 15.3407C3.75027 15.1599 0.650391 11.9445 0.650391 8C0.650391 3.93994 3.93994 0.650391 8 0.650391H8.02371C9.89371 0.659282 11.6007 1.36461 12.8958 2.52039C12.0364 1.94546 11.0258 1.61947 9.95299 1.61947ZM12.9699 13.4055C11.7578 14.1375 10.2819 14.1049 9.05799 13.2336C10.7235 12.6261 11.9534 10.519 11.9534 8C11.9534 5.48987 10.7324 3.38279 9.06688 2.76637C10.3056 1.90101 11.7696 1.86841 13.0054 2.61819C16.1438 5.54322 16.132 10.4924 12.9699 13.4055Z" />
    </Icon>
  );
};
